export const parseJSON = <T = unknown>(input: string, transform?: (this: any, key: string, value: any) => any) => {
  try {
    const result = JSON.parse(input, transform)
    return [undefined, result] as [undefined, T]
  } catch (e) {
    return [e] as [Error]
  }
}
